<!-- <mat-form-field appearance="fill" class="w-100">
    <mat-select
        placeholder="{{ placeholder }}"
        class="form-control"
        [formControl]="control"
        msInfiniteScroll
        (infiniteScroll)="onScroll()"
        [complete]="offset >= totalCount"
        (selectionChange)="onSelectionChange($event)"
    >
        <mat-option>
            <ngx-mat-select-search
                [formControl]="searchControl"
                [clearSearchInput]="search_entiry.clear_search_input"
                placeholderLabel="Find name..."
                noEntriesFoundLabel="No matching name found"
            ></ngx-mat-select-search>
        </mat-option>
        <mat-option
            (click)="onSelect(item.id)"
            *ngFor="let item of items"
            [value]="item.id"
        >
            {{ item.name }}
        </mat-option>
    </mat-select>
</mat-form-field> -->


<mat-form-field
                        appearance="fill"
                    >
                    <mat-select
                    placeholder="{{ placeholder }}"
                    class="form-control"
                    [formControl]="control"
                    msInfiniteScroll
                    (infiniteScroll)="onScroll()"
                    [complete]="offset >= totalCount"
                    (selectionChange)="onSelectionChange($event)"
                >
                    <mat-option>
                        <ngx-mat-select-search
                            [formControl]="searchControl"
                            [clearSearchInput]="search_entiry.clear_search_input"
                            placeholderLabel="Find name..."
                            noEntriesFoundLabel="No matching name found"
                        ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        (click)="onSelect(item.id)"
                        *ngFor="let item of items"
                        [value]="item.id"
                    >
                        {{ item.name }}
                    </mat-option>
                </mat-select>
                    </mat-form-field>
